import { ButtonTextVariant } from '@kanda-libs/ks-design-library';

export const MODAL_ID = 'ob-sign-docs-modal';

export const FORM_ID = 'ob-sign-docs-form';

export const DEFAULT_NEXT_BUTTON_PROPS = {
  id: 'ob-sat-note-next',
  label: 'Next',
  className: 'w-full mt-6',
  icon: 'arrow-right',
  variant: 'gradient' as ButtonTextVariant,
  submit: false,
};
